// extracted by mini-css-extract-plugin
module.exports = {"errors":"validation-summary_errors__20G8H","list":"validation-summary_list__1FQbX"};